import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BookingSlot } from '../../models/booking-slot';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';

@Component({
  selector: 'app-time-slot-diagram',
  templateUrl: './time-slot-diagram.component.html',
  styleUrls: ['./time-slot-diagram.component.css']
})
export class TimeSlotDiagramComponent implements OnInit {

  @ViewChild('scroller', {static: true}) scroller: any;

  @Input()
  defaultFatorSlotIsFull = 0.95;

  @Output()
  timeSlotSelected: EventEmitter<BookingSlot> = new EventEmitter<BookingSlot>();

  constructor(
    private bookingSlotStateService: BookingSlotStateService,
  ) { }

  ngOnInit() {
  }

  get bookingSlots(): Array<BookingSlot> {
    return this.bookingSlotStateService.validBookingSlots;
  }

  get selectedSlot(): BookingSlot {
    return this.bookingSlotStateService.selectedSlot;
  }

  isSlotSelected(slot: BookingSlot): boolean {
    if (!this.selectedSlot) {
      return false;
    }
    return slot.id === this.selectedSlot.id;
  }

  getBookingSlotHeight(bookingSlot: BookingSlot): number {
    return 20 + bookingSlot.bookedQuantity / bookingSlot.capacity * 80;
  }

  onClickBookingSlot($event, bookingSlot: BookingSlot) {
    this.bookingSlotStateService.selectedSlot = bookingSlot;
    const element = this.scroller.nativeElement;
    const scrollit = this._getScrollCount($event);
    element.scrollLeft = scrollit;
  }

  private _getScrollCount($event): number {
    const width = window.innerWidth / 2.1;
    const elem = $event.currentTarget;
    const parent = $event.currentTarget.parentElement;
    const offset = elem.offsetLeft - parent.offsetLeft;
    const scrollit = offset - width;

    return scrollit;
    //      $('.scrolling-wrapper-flexbox').animate({scrollLeft: scrollit }, 1000);
  }

  getBookingSlotToolTip(bookingSlot: BookingSlot): string {

    const freeQuantity = bookingSlot.freeQuantity;
    const freeQuantityPercent = bookingSlot.freeQuantity / bookingSlot.capacity * 100;

    switch (true) {
      case (freeQuantity === 0 || !this.canSelectSlot(bookingSlot)):
        return 'Ticket_Tooltip_0';
      case (freeQuantity === 1):
        return 'Ticket_Tooltip_1';
      case (freeQuantity >= 2 && freeQuantity <= 10):
        return 'Ticket_Tooltip_Few';
      case (freeQuantity >= 11 && freeQuantityPercent <= 20):
        return 'Ticket_Tooltip_Limited';
      case (freeQuantityPercent > 20):
        return 'Ticket_Tooltip_Enough';
      default:
        return 'Ticket_Tooltip_Few';
    }
  }

  canSelectSlot(bookingSlot: BookingSlot): boolean {
    return this.bookingSlotStateService.canSelectSlot(bookingSlot);
  }
}
